import React, { useState } from 'react'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { useStyles } from './styles'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import { MoreHoriz } from '@material-ui/icons'
import { DateTime } from 'luxon'
import { useIsTablet } from 'lib/hooks'
import SyncAltOutlinedIcon from '@material-ui/icons/SyncAltOutlined'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import RemoveSponsorshipModal from './remove-sponsorship-modal'
import { CreateEndorsementInvitation } from './queries'
import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'

const SponsorshipItemView = ({ endorsement, refetch }) => {
  const { name, status, title, expiredAt, facility, id, email } = endorsement
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const isTablet = useIsTablet()
  const [anchorEl, setAnchorEl] = useState(null)
  const [removeSponsorshipOpen, setRemoveSponsorshipOpen] = useState(false)
  const [CreateEndorsement] = useMutation(CreateEndorsementInvitation)

  const handleMoreHorClick = event => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = event => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const handleRemoveSponsorship = event => {
    event.stopPropagation()
    setRemoveSponsorshipOpen(true)
    setAnchorEl(null)
  }

  const handleResendSponsorship = async event => {
    event.stopPropagation()
    try {
      const response = await CreateEndorsement({
        variables: {
          input: {
            firstName: name.split(' ')[0],
            lastName: name.split(' ')[1],
            email: email,
            title: title,
            facilityId: facility.id,
          },
        },
      })
      if (response?.data?.createEndorsementInvitation.success) {
        enqueueSnackbar('Endorsement Resent', {
          variant: 'success',
        })
        refetch()
      }
    } catch (e) {
      enqueueSnackbar('Sorry, an error occurred', {
        variant: 'error',
      })
    } finally {
      setAnchorEl(null)
    }
  }

  const statusesMapper = {
    active: {
      label: 'Accepted',
      class: classes.active,
    },
    expired: {
      label: 'Expired',
      class: classes.expired,
    },
    pending: {
      label: 'Invited',
      class: classes.pending,
    },
  }

  return (
    <>
      <TableRow>
        <TableCell>
          <List disablePadding={true}>
            <ListItem>
              <ListItemIcon>
                <Avatar className={classes.studentAvatar} />
              </ListItemIcon>
              <Box pl={2} className={classes.link}>
                <ListItemText
                  disableTypography
                  primary={<Typography variant="body1">{name}</Typography>}
                />
                <ListItemText>
                  <Typography variant="body2" color="textSecondary">
                    {title}
                  </Typography>
                </ListItemText>
              </Box>
            </ListItem>
          </List>
        </TableCell>
        {!isTablet && (
          <>
            <TableCell>
              <Typography variant="body1">
                {DateTime.fromISO(expiredAt).toFormat('MMM dd, yyyy')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body1">{facility.name}</Typography>
            </TableCell>
          </>
        )}
        <TableCell>
          <Chip
            label={statusesMapper[status].label}
            className={`${classes.chip} ${statusesMapper[status].class}`}
          />
        </TableCell>
        <TableCell align="right">
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleMoreHorClick}
          >
            <MoreHoriz className={classes.icon} />
          </Button>
        </TableCell>
      </TableRow>
      <Menu
        id="simple-menu"
        keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {status !== 'active' && (
          <MenuItem onClick={handleResendSponsorship}>
            <ListItemIcon>
              <SyncAltOutlinedIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText primary="Resend Sponsorship" />
          </MenuItem>
        )}
        {status !== 'expired' && (
          <MenuItem onClick={handleRemoveSponsorship}>
            <ListItemIcon>
              <CancelOutlinedIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText primary="Remove Access" />
          </MenuItem>
        )}
      </Menu>
      <RemoveSponsorshipModal
        open={removeSponsorshipOpen}
        endorsementId={id}
        onClose={() => setRemoveSponsorshipOpen(false)}
        refetch={refetch}
      />
    </>
  )
}

export default SponsorshipItemView
